import { Skeleton } from '@/components/ui/Skeleton';
import { useAdminQueues } from '@/hooks/useAdminAutomations';
import { QueueStatusCard } from '../components/QueueStatusCard';
import { BrowserPoolStatus } from '../components/BrowserPoolStatus';

export function AutomationQueuesPage() {
  const { data, isLoading } = useAdminQueues();
  // Service already normalizes to QueueStats[] array
  const queues = data || [];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Files d'attente</h1>
        <p className="text-sm text-neutral-500">Gestion des queues Bull et du pool Puppeteer</p>
      </div>

      <div>
        <h2 className="mb-3 text-sm font-semibold text-neutral-600 dark:text-neutral-300">Queues</h2>
        {isLoading ? (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2"><Skeleton className="h-32" /><Skeleton className="h-32" /></div>
        ) : (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {queues.map((queue) => (
              <QueueStatusCard key={queue.name} queue={queue} />
            ))}
            {queues.length === 0 && (
              <p className="text-sm text-neutral-500 col-span-2">Aucune queue trouvée</p>
            )}
          </div>
        )}
      </div>

      <BrowserPoolStatus />
    </div>
  );
}
